var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.shape},[(_vm.src)?_c('img',{staticClass:"uk-border-circle",attrs:{"src":_vm.src}}):(_vm.email)?_c('Gravatar',{attrs:{"email":_vm.email,"height":_vm.getSize,"width":_vm.getSize,"default-img":"identicon"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }